import { useEffect, useState } from 'react';

export const useCurrentTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  useEffect(() => {
    const checkTheme = () => {
      const isDark = document.body.classList.contains('theme-dark');
      setIsDarkMode(isDark);
    };

    // Initial check
    checkTheme();

    // Set up observer to watch for class changes
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return { isDarkMode };
};
